<template>
  <div class="outer-container">
    <div class="header">{{ $t('oneMoreThing') }}</div>
    <div class="line-spacing big-text rich-text-editor-custom-css" v-html="optionalQuestion" />
    <div class="line-spacing big-text">
      <textarea style="border: 1px solid black;" v-model="answer" rows="4" cols="40"></textarea>
    </div>
    <div class="line-spacing">
      <button class="pure-button bigmi-red-2-button" v-on:click="submit">{{ $t('submit') }}</button>
    </div>
  </div>
</template>

<script>
import { GET_BACKEND_URL, USER_POSITION_IN_SURVEY, COMPLETE_SURVEY } from "../../services/constants"
import http from "../../services/axios"

export default {
  name: 'SurveyOneMoreThing',

  data () {
    return {
      answer: '',
    }
  },
  methods: {
    submit () {
      if (this.$store.state.surveyModule.isSurveyPreview) {
        this.$store.dispatch(USER_POSITION_IN_SURVEY, { sendToAdditionalQuestion: false })
      } else {
        let answerPayload = { 'optionalQuestionAnswer': this.answer }
        let studyID = this.$store.state.surveyModule.survey.data.study.id
        let uniqueIdentifier = this.$route.params.survey_id
        http.post(this.$store.getters[GET_BACKEND_URL](`studies/${studyID}/participants/${uniqueIdentifier}/optional-question`), answerPayload).then(response => {
          this.$store.dispatch(COMPLETE_SURVEY, this.$route.params.survey_id)
          this.$store.dispatch(USER_POSITION_IN_SURVEY, { sendToAdditionalQuestion: false })
          if (this.isDelayedRedirectNeeded) {
            setTimeout(this.delayedRedirectFromDonePage, 5000);
          }
        }).catch(err => {
          console.error(err)
        })
      }
    },
    delayedRedirectFromDonePage () {
      this.$store.dispatch(USER_POSITION_IN_SURVEY, { sendToCompletedPage: false })
    }
  },
  computed: {
    optionalQuestion () {
      return this.$store.state.surveyModule.survey.data.study.optionalQuestion
    },
    isProspx () {
      return this.$store.state.surveyModule.survey.data.study.brand === "prospx"
    },
    isRedirectUrl () {
      return this.$store.state.surveyModule.redirectURL && this.$store.state.surveyModule.redirectURL.length > 0
    },
    isDelayedRedirectNeeded () {
      return this.isProspx && this.isRedirectUrl
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../scss/main";

.outer-container {
  padding: 5%;
  max-width: 1024px;
  @media #{$mobile} {
    width: 80%;
  }
}

.header {
  padding-top: 10%;
  padding-bottom: 5%;
  color: $red-2;
  font-weight: bold;
  font-size: 17px;
}

.big-text {
  font-size: 17px;
}

.small-text {
  font-size: 13px;
}

.button {
  border-color: $red-2;
  font-weight: bold;
  background-color: $white-1;
  border-width: medium;
  color: $red-2;
  border-radius: 3px;
  padding: 10px 20px;
}

.line-spacing {
  padding-top: 5%;
  padding-bottom: 5%;
}
</style>
